module.exports = __webpack_public_path__ + "img/album12_13.e290deb4.jpg";